import "./homeBase.css";

import PageHero from "../../../shared/components/sections/PageHero/PageHero";
import ProceduresSection from "./components/ProceduresSection/ProceduresSection";
import AboutPreview from "./components/AboutPreview/AboutPreview";
import ClinicSection from "./components/ClinicSection/ClinicSection";
import BenefitsSection from "./components/BenefitsSection/BenefitsSection";
import TestimonialsSection from "./components/TestimonialsSection/TestimonialsSection";
import ContactSection from "./components/ContactSection/ContactSection";
import FinalCtaSection from "./components/FinalCtaSection/FinalCtaSection";
import HomeFooterWave from "./components/HomeFooterWave/HomeFooterWave";

import { useExperience } from "../../../shared/context/ExperienceContext";
import { heroContentByMode } from "./data/homeData";

export default function HomePage() {
  const { mode } = useExperience();

  const heroContent = heroContentByMode?.[mode] || heroContentByMode?.all || {};

  return (
    <main className="home-page" data-home-mode={mode}>
      <PageHero content={heroContent} className="home-page__hero" />

      <ProceduresSection />
      <AboutPreview />
      <ClinicSection />
      <BenefitsSection />
      <TestimonialsSection />
      <ContactSection />
      <FinalCtaSection />
      <HomeFooterWave />
    </main>
  );
}